import { styled } from '@mui/material';
import { Typography } from 'core/common/ui/ui-kit';
import { animationDurationMs } from './useTransitions';

export const WrapperStyled = styled('div')``;

export const TextStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isVisible',
})<{ isVisible: boolean }>`
  text-align: center;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity ${animationDurationMs}ms ease-in-out;
`;
